import axios from "axios";
import { getRefresh, setAccess, setRefresh } from "./token";

export const refreshToken = async (baseUri: string) => {
    try {
        const { data } = await axios({
            url: `${baseUri}/auth/token`,
            method: 'POST',
            headers: {
                Authorization: `Bearer ${getRefresh()}`,
            },
        });

        const { refresh_token, access_token } = data.data;
        setAccess(access_token);
        setRefresh(refresh_token);
    } catch (error) {
        return Promise.reject(error);
    }
}